import { render, staticRenderFns } from "./Wizard-Location.vue?vue&type=template&id=6ff306ce&scoped=true"
import script from "./Wizard-Location.vue?vue&type=script&lang=ts"
export * from "./Wizard-Location.vue?vue&type=script&lang=ts"
import style0 from "./Wizard-Location.vue?vue&type=style&index=0&id=6ff306ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff306ce",
  null
  
)

export default component.exports